/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ProposalClientResource } from './';
import {
    ProposalClientResourceFromJSON,
    ProposalClientResourceFromJSONTyped,
    ProposalClientResourceToJSON,
} from './';
import type { ProposalResource } from './';
import {
    ProposalResourceFromJSON,
    ProposalResourceFromJSONTyped,
    ProposalResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProposalWithClientResource
 */
export interface ProposalWithClientResource {
    /**
     * 
     * @type {ProposalResource}
     * @memberof ProposalWithClientResource
     */
    proposal: ProposalResource;
    /**
     * 
     * @type {ProposalClientResource}
     * @memberof ProposalWithClientResource
     */
    client: ProposalClientResource;
}

/**
 * Check if a given object implements the ProposalWithClientResource interface.
 */
export function instanceOfProposalWithClientResource(value: object): value is ProposalWithClientResource {
    if (!('proposal' in value) || value['proposal'] === undefined) return false;
    if (!('client' in value) || value['client'] === undefined) return false;
    return true;
}

export function ProposalWithClientResourceFromJSON(json: any): ProposalWithClientResource {
    return ProposalWithClientResourceFromJSONTyped(json, false);
}

export function ProposalWithClientResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProposalWithClientResource {
    if (json == null) {
        return json;
    }
    return {
        
        'proposal': ProposalResourceFromJSON(json['proposal']),
        'client': ProposalClientResourceFromJSON(json['client']),
    };
}

export function ProposalWithClientResourceToJSON(value?: ProposalWithClientResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'proposal': ProposalResourceToJSON(value['proposal']),
        'client': ProposalClientResourceToJSON(value['client']),
    };
}

